export default __webpack_public_path__ + "static/media/dns.8f62c29a.svg";